module.exports = __webpack_public_path__ + "img/email.84f961e2.svg";